export const isEmpty = (text) => {
    return !text || text === '';
};
//# sourceMappingURL=stringUtils.js.map